import {useContext} from 'react';
import {ThemeType} from './types';
import {ThemeContext} from './themeContext';

export const useTheme = (): ThemeType => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw Error(
      'Theme Context could not be found. Did you wrap your container in a theme provider?',
    );
  }
  return context;
};
